import { render, staticRenderFns } from "./ChangeCourseCom.vue?vue&type=template&id=77535ce7&scoped=true"
import script from "./ChangeCourseCom.vue?vue&type=script&lang=js"
export * from "./ChangeCourseCom.vue?vue&type=script&lang=js"
import style0 from "./ChangeCourseCom.vue?vue&type=style&index=0&id=77535ce7&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77535ce7",
  null
  
)

export default component.exports